import React from 'react'
import { RealEstateDataPage, RealEstateDataPageComponentData } from 'types'
import Table from '../1'
interface ExternalProps {
  pages: RealEstateDataPage[]
  currentPage: RealEstateDataPage[]
  development_id?: string
  property_id?: string
}

type CombinedProps = RealEstateDataPageComponentData & ExternalProps

const FavoritesTable = ({ global_data, is_wide, is_short }: CombinedProps) => {
  return (
    <Table
      is_wide={is_wide}
      global_data={global_data}
      is_short={is_short}
    />
  )
}

export default FavoritesTable
